import React, { useEffect, useState } from 'react';
import { useSearchParams, Link as RouterLink } from 'react-router-dom';
import { Box, Alert, Button, Typography } from '@mui/material';
import { controller } from '../api/controller';

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Подтверждаем email...');

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!token) {
        setStatus('error');
        setMessage('Отсутствует токен подтверждения.');
        return;
      }
      try {
        await controller.verifyEmailByToken(token);
        if (cancelled) return;
        setStatus('success');
        setMessage('Email подтвержден. Теперь можно войти в систему.');
      } catch (err) {
        if (cancelled) return;
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          'Не удалось подтвердить email.';
        setStatus('error');
        setMessage(msg);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0a1a2f',
        p: 2,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 480 }}>
        <Alert severity={status === 'success' ? 'success' : status === 'error' ? 'error' : 'info'}>
          {message}
        </Alert>
        <Typography sx={{ mt: 2, color: '#b0bec5' }}>
          После подтверждения вернитесь на страницу входа.
        </Typography>
        <Button component={RouterLink} to="/v2/login" variant="contained" sx={{ mt: 2 }}>
          Открыть логин
        </Button>
      </Box>
    </Box>
  );
}

export default VerifyEmailPage;
